module.exports = __webpack_public_path__ + "img/gold.6367ac4.png";